<nz-space class="mobile-report-control">
    <app-pdn-select [(ngModel)]="from" class="report-control" (ngModelChange)="fromChange.emit($event)"
      valueField="docCode">
    </app-pdn-select>
    <span class="text-center">
      <span nz-icon nzType="swap-right" nzTheme="outline"></span>
    </span>
    <app-pdn-select [(ngModel)]="to" class="report-control" (ngModelChange)="toChange.emit($event)" valueField="docCode">
    </app-pdn-select>
</nz-space>
  